import { MenuItems } from './components/MenuItems'
import menuList from './menuList'
import * as S from './styled'

const Sidebar = ({
  userName,
  isLoyalty,
  currentMenu,
  loyaltyProgramCode,
  loyaltyProRelationship
}) => {
  const isOnLoyalty = !!isLoyalty
  const avaliableMenu = menuList({
    isOnLoyalty,
    loyaltyProgramCode,
    loyaltyProRelationship
  })

  return (
    <S.Wrapper>
      <S.Header>
        <S.UserAvatar isOnLoyalty={isOnLoyalty}>
          <S.UserPhoto>{userName.split('')[0]}</S.UserPhoto>
        </S.UserAvatar>
        <S.UserName>
          Olá, <div>{userName}</div>
        </S.UserName>
      </S.Header>

      <S.Nav>
        <S.ContentTitle>Minha Conta</S.ContentTitle>
        {avaliableMenu
          .filter(menu => menu.isActive)
          .map((menu, id) => (
            <MenuItems key={id} menu={menu} currentMenu={currentMenu} />
          ))}
      </S.Nav>
    </S.Wrapper>
  )
}

export default Sidebar
